import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_private/_home/project/$project_id/settings/')({
  beforeLoad: ({ params }) => {
    throw redirect({ to: '/project/$project_id/settings/export', params, replace: true });
  },
});
